import React, { useState, useEffect, useRef } from 'react';
import {
  DefaultButton,
  Dropdown,
  IComboBoxOption,
  IDropdownOption,
  Icon,
  Label,
  Text,
  TextField,
  Toggle,
  IconButton,
} from '@fluentui/react';
import DialogTemplate from '../Common/DialogTemplate';
import IPeriodos from './PlanillaDigitalView';
import { HourSelector } from '../Common/HourSelector';
import SystemClient from '../../system/SystemClient';
import PlanillaDigitalForm from './PlanillaDigitalForm';
import { PrimaryButton } from 'office-ui-fabric-react';

interface IPlanillaDigitalTimer {
  system: SystemClient;
  minutes: number;
  seconds: number;
  isPaused: boolean;
  hasStarted: boolean;
  pause: () => void;
  resume: () => void;
  start: () => void;
  setHasStarted: (v: boolean) => void;
  //@ts-ignore
  currentPeriod: IPeriodos;
  //@ts-ignore
  periodos: IPeriodos[];
  periodoSeleccionable: boolean;
  //@ts-ignore
  setPeriodos: (p: IPeriodos[]) => void;
  showPenales: boolean;
  enablePenales: boolean;
  countdownMode: boolean;
  setEnablePenales: (v: boolean) => void;
  setShowPenales: (v: boolean) => void;
  setMatchIsOver: (v: boolean) => void;
  restart: (newExpiryTimestamp: Date, autoStart?: boolean | undefined) => void;
  matchIsOver: boolean;
  periodoStarted: boolean;
  setPeriodoStarted: (v: boolean) => void;
  initPartido: () => Promise<void>;
  form: PlanillaDigitalForm;
  setErrorMsg: (v: string) => void;
  setShowAlertDialog: (v: boolean) => void;
}
const PlanillaDigitalTimer = ({
  system,
  minutes,
  seconds,
  isPaused,
  hasStarted,
  pause,
  resume,
  start,
  restart,
  setHasStarted,
  currentPeriod,
  periodos,
  periodoSeleccionable,
  setPeriodos,
  showPenales,
  enablePenales,
  setEnablePenales,
  setShowPenales,
  setMatchIsOver,
  countdownMode,
  matchIsOver,
  initPartido,
  form,
  periodoStarted,
  setPeriodoStarted,
  setErrorMsg,
  setShowAlertDialog,
}: IPlanillaDigitalTimer) => {
  const onChangePeriodoSeleccionable = (next: boolean) => {
    const _periodos = [...periodos];

    const current = _periodos.find((p) => p.isPlaying);
    const idx = _periodos.findIndex((p) =>
      next ? p.tiempo === current.tiempo + 1 : p.tiempo === current.tiempo - 1
    );

    if (current && idx > -1) {
      current.isPlaying = false;
      current.isFinished = next ? true : false;
      _periodos[idx].isPlaying = true;
      _periodos[idx].isFinished = false;
      let primerosMinutos = 0;
      const resultado: any = {};

      _periodos.forEach((periodo) => {
        resultado[periodo.tiempo] = primerosMinutos + 1;
        primerosMinutos += periodo.durationInMinutes;
      });

      setPeriodos(_periodos);
      // setMinutes(1);
    }
  };

  const irAPenales = () => {
    const _periodos = [...periodos];
    _periodos.forEach((p) => (p.isFinished = true));
    setPeriodos(_periodos);
    setEnablePenales(true);
    setPenalesActive(true);
  };

  const togglePause = () => {
    if (!periodoStarted) {
      setPeriodoStarted(true);
    }

    if (!matchIsOver) {
      if (hasStarted) {
        if (isPaused) {
          resume();
        } else {
          pause();
        }
      } else {
        setHasStarted(true);
        start();
      }
    }
  };

  const [showEditDialog, setShowEditDialog] = React.useState<boolean>(false);
  const [editedClock, setEditedClock] = React.useState<string>('00:00');

  const [penalesActive, setPenalesActive] = React.useState<boolean>(false);

  const editTimer = () => {
    const min = +editedClock.split(':')[0];
    const segs = +editedClock.split(':')[1];

    if (countdownMode) {
      const time = new Date();
      time.setSeconds(time.getSeconds() + min * 60 + segs);
      restart(time, false);
    } else {
      const duracionSegundos = currentPeriod.durationInMinutes! * 60;
      const tiempoFaltanteSegundos = min * 60 + segs;

      const tiempoTranscurridoSegundos = duracionSegundos - tiempoFaltanteSegundos;
      const minutosTranscurridos = Math.floor(tiempoTranscurridoSegundos / 60);
      const segundosTranscurridos = tiempoTranscurridoSegundos % 60;

      const time = new Date();
      time.setSeconds(time.getSeconds() + minutosTranscurridos * 60 + segundosTranscurridos);
      restart(time, false);
    }

    setShowEditDialog(false);
  };

  const classNameContainer = () => {
    if (!hasStarted) {
      return 'not-started-timer ms-depth-4 clickable';
    } else if (isPaused) {
      return 'stopped-timer ms-depth-4 clickable';
    } else {
      return ' playing-timer  ms-depth-4 clickable';
    }
  };

  const timerColor = () => {
    if (!hasStarted && !enablePenales) {
      return 'grey';
    } else if (isPaused && !enablePenales) {
      return ' #f07878';
    } else if (enablePenales) {
      return '#37bc9b';
    } else {
      return '#37bc9b';
    }
  };

  const calcularProgresivo = () => {
    // Convierte la duración a segundos
    if (currentPeriod) {
      const duracionSegundos = currentPeriod.durationInMinutes! * 60;

      // Convierte los minutos y segundos faltantes a segundos
      const tiempoFaltanteSegundos = minutes * 60 + seconds;

      // Calcula el tiempo transcurrido en segundos
      const tiempoTranscurridoSegundos = duracionSegundos - tiempoFaltanteSegundos;

      // Convierte el tiempo transcurrido de nuevo a minutos y segundos
      const minutosTranscurridos = Math.floor(tiempoTranscurridoSegundos / 60);
      const segundosTranscurridos = tiempoTranscurridoSegundos % 60;

      // Formatea los minutos y segundos transcurridos como cadena HH:mm
      const formatoMinutos = minutosTranscurridos.toString().padStart(2, '0');
      const formatoSegundos = segundosTranscurridos.toString().padStart(2, '0');

      return `${formatoMinutos}:${formatoSegundos}`;
    }
    return '00:00';
  };

  const iniciarPartido = () => {
    setHasStarted(true);
    initPartido();
  };

  React.useEffect(() => {
    const togglePauseByKeyboard = (event: KeyboardEvent) => {
      if (event.code === 'Space') {
        event.preventDefault();
        togglePause();
      }
    };

    window.addEventListener('keydown', togglePauseByKeyboard);

    return () => {
      window.removeEventListener('keydown', togglePauseByKeyboard);
    };
  }, [togglePause]);

  return (
    <div>
      {!periodoSeleccionable ? (
        <div className={classNameContainer()}>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm2">
              <div
                style={{
                  position: 'relative',
                  top: '0px',
                  // marginLeft: '30%',
                  fontSize: 50,
                  paddingTop: 10,
                  paddingBottom: 10,
                  width: '200%',
                  backgroundColor: timerColor(),
                }}
              >
                <Icon
                  iconName="Timer"
                  style={{
                    fontSize: 40,
                    color: timerColor() !== 'grey' ? 'white' : 'black',
                  }}
                ></Icon>
              </div>
            </div>
            <div className="ms-Grid-col ms-sm10 text-center">
              <Icon
                className=""
                iconName="Settings"
                style={{
                  position: 'absolute',
                  top: '7%',
                  right: '6%',
                  fontSize: 15,
                  zIndex: 1,
                }}
                onClick={() => {
                  pause();
                  setShowEditDialog(true);
                }}
              ></Icon>

              {!showPenales ? (
                <>
                  <div
                    className="ms-Grid-col ms-sm12 text-center"
                    onClick={() => {
                      togglePause();
                      if (!hasStarted) {
                        iniciarPartido();
                      }
                    }}
                    style={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    <Text style={{ fontWeight: 600, fontSize: 37 }}>
                      {countdownMode ? (
                        <span>
                          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                        </span>
                      ) : (
                        <span>{calcularProgresivo()}</span>
                      )}
                      <Text
                        style={{
                          fontWeight: 600,
                          fontSize: 16,
                          position: 'relative',
                          bottom: 7,
                          marginLeft: 5,
                        }}
                      >
                        {currentPeriod ? currentPeriod.desc : ''}
                      </Text>
                    </Text>
                  </div>
                  <div
                    className="ms-Grid-col ms-sm12 text-center text-overflow"
                    onClick={() => togglePause()}
                  >
                    <Text
                      style={{ display: 'block', fontWeight: 400, fontSize: 10 }}
                      title={isPaused ? 'Click para iniciar' : 'Click para detener'}
                    >
                      <Icon
                        iconName="Info"
                        style={{ position: 'relative', top: '0px', marginRight: 2, fontSize: 8 }}
                      ></Icon>
                      {isPaused ? 'Click para iniciar' : 'Click para detener'}
                    </Text>
                  </div>
                </>
              ) : (
                <div
                  onClick={() => {
                    if (!enablePenales && !penalesActive) {
                      setEnablePenales(true);
                      setPenalesActive(true);
                    } else if (enablePenales && penalesActive) {
                      if (
                        form.getCantidadGolesLocal() +
                          +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesLocal()! !==
                        form.getCantidadGolesVisitante() +
                          +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesVisitante()!
                      ) {
                        setEnablePenales(false);
                        setMatchIsOver(true);
                      } else {
                        setErrorMsg('El partido no puede terminar en empate');
                        setShowAlertDialog(true);
                      }
                    }
                  }}
                >
                  <div
                    className="ms-Grid-col ms-sm12 text-center"
                    style={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    <Text style={{ fontWeight: 600, fontSize: 30 }}>PENALES</Text>
                  </div>
                  <div className="ms-Grid-col ms-sm12 text-center text-overflow">
                    <Text
                      style={{ display: 'block', fontWeight: 400, fontSize: 12 }}
                      title={
                        !enablePenales
                          ? !penalesActive
                            ? 'Click para iniciar'
                            : 'Penales finalizados'
                          : 'Click para terminar'
                      }
                    >
                      <Icon
                        iconName="Info"
                        style={{ position: 'relative', top: '0px', marginRight: 2, fontSize: 8 }}
                      ></Icon>
                      {!enablePenales
                        ? !penalesActive
                          ? 'Click para iniciar'
                          : 'Penales finalizados'
                        : 'Click para terminar'}
                    </Text>
                  </div>
                </div>
              )}

              <DialogTemplate
                showDialog={showEditDialog}
                toggleShowDialog={() => {
                  setShowEditDialog(false);
                }}
                title={'Atención!'}
                onAccept={() => editTimer()}
                onCancel={() => {
                  setShowEditDialog(false);
                }}
                acceptText={'Editar'}
                cancelText={'Volver'}
              >
                <>
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <Label>Seleccioná el minuto y segundo al que quieres cambiar.</Label>
                      <HourSelector
                        useLabel={false}
                        useHalf
                        onChange={(v) => setEditedClock(v)}
                        hour={+editedClock.split(':')[0]}
                        minute={+editedClock.split(':')[1]}
                        maxFirstSelector={currentPeriod ? +currentPeriod.durationInMinutes : 30}
                      ></HourSelector>
                    </div>
                  </div>
                </>
              </DialogTemplate>
            </div>
          </div>
        </div>
      ) : (
        <>
          {currentPeriod && (currentPeriod.tiempo == 2 || currentPeriod.tiempo == 4) && (
            <div
              className={'ms-depth-4 ms-Grid-col ms-sm12'}
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                height: '100%',
              }}
            >
              <PrimaryButton
                onClick={() => {
                  setMatchIsOver(true);
                }}
                disabled={
                  form.getCantidadGolesLocal() +
                    +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesLocal()! ===
                  form.getCantidadGolesVisitante() +
                    +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesVisitante()!
                }
              >
                Finalizar partido
              </PrimaryButton>
            </div>
          )}
          {!matchIsOver && (
            <div
              className={'ms-depth-4 clickable ms-Grid-col ms-sm12 mt-2'}
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                height: '100%',
              }}
            >
              {!showPenales ? (
                <div className="ms-Grid-row mb-1">
                  <div className="ms-Grid-col ms-sm12 text-center">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm2 mt-1">
                        <IconButton
                          iconProps={{ iconName: 'ChevronLeft' }}
                          title="Anterior"
                          onClick={() => {
                            onChangePeriodoSeleccionable(false);
                          }}
                          style={{ float: 'inline-start' }}
                        />
                      </div>
                      <div className="ms-Grid-col ms-sm8" style={{ marginTop: 10 }}>
                        <Text variant="medium" style={{ display: 'block' }}>
                          Selecciona el periodo
                        </Text>
                      </div>
                      <div className="ms-Grid-col ms-sm2 mt-1">
                        <IconButton
                          iconProps={{ iconName: 'ChevronRight' }}
                          title="Anterior"
                          onClick={() => {
                            onChangePeriodoSeleccionable(true);
                          }}
                          style={{ float: 'left' }}
                        />
                      </div>
                    </div>
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12 text-center">
                        <div className="mt-2" style={{ borderBottom: '1px solid #000' }}></div>
                      </div>

                      <div className="mt-2">
                        <Text variant="mediumPlus" style={{ display: 'block' }}>
                          {currentPeriod?.longDesc}
                        </Text>
                      </div>
                      {currentPeriod &&
                        !currentPeriod.required &&
                        !periodos.find((p) => p.tiempo === currentPeriod.tiempo + 1) &&
                        form.getCantidadGolesLocal() +
                          +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesLocal()! ===
                          form.getCantidadGolesVisitante() +
                            +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesVisitante()! && (
                          <Text
                            variant="mediumPlus"
                            style={{ display: 'block' }}
                            className="link-styles"
                            onClick={() => {
                              setShowPenales(true);
                              irAPenales();
                            }}
                          >
                            Ir a penales
                          </Text>
                        )}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => {
                    if (!enablePenales && !penalesActive) {
                      setEnablePenales(true);
                      setPenalesActive(true);
                    } else if (enablePenales && penalesActive) {
                      if (
                        form.getCantidadGolesLocal() +
                          +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesLocal()! !==
                        form.getCantidadGolesVisitante() +
                          +form.getPlanillaPartidoInput().getValue().getPartido()!.getGolesVisitante()!
                      ) {
                        setEnablePenales(false);
                      } else {
                        setErrorMsg('El partido no puede terminar en empate');
                        setShowAlertDialog(true);
                      }
                    }
                  }}
                >
                  <div
                    className="ms-Grid-col ms-sm12 text-center"
                    style={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    <Text style={{ fontWeight: 600, fontSize: 30 }}>PENALES</Text>
                  </div>
                  <div className="ms-Grid-col ms-sm12 text-center text-overflow">
                    <Text
                      style={{ display: 'block', fontWeight: 400, fontSize: 10 }}
                      title={
                        !enablePenales
                          ? !penalesActive
                            ? 'Click para iniciar'
                            : 'Penales finalizados'
                          : 'Click para terminar'
                      }
                    >
                      <Icon
                        iconName="Info"
                        style={{ position: 'relative', top: '0px', marginRight: 2, fontSize: 8 }}
                      ></Icon>
                      {!enablePenales
                        ? !penalesActive
                          ? 'Click para iniciar'
                          : 'Penales finalizados'
                        : 'Click para terminar'}
                    </Text>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PlanillaDigitalTimer;
